import { render } from "./Others25Charts.vue?vue&type=template&id=70babb87&scoped=true"
import script from "./Others25Charts.vue?vue&type=script&lang=js"
export * from "./Others25Charts.vue?vue&type=script&lang=js"

import "./Others25Charts.vue?vue&type=style&index=0&id=70babb87&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70babb87"]])

export default __exports__